
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[campaign]/auth/signin",
      function () {
        return require("private-next-pages/[campaign]/auth/signin.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[campaign]/auth/signin"])
      });
    }
  